import {
  parseCandidateWriteFailureSettings,
} from "@/lib/candidateWriteReliability";

export function useCandidateWriteFailureSettings() {
  const { site } = useSite();

  const configuration = computed(() =>
    parseCandidateWriteFailureSettings(
      (site.value?.settings ?? {}) as Record<string, unknown>,
    ),
  );

  return { configuration };
}
